function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#FFEA00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.11 16.4453C39.9733 16.5835 39.8105 16.6932 39.6312 16.768C39.4518 16.8429 39.2594 16.8814 39.065 16.8814C38.8706 16.8814 38.6782 16.8429 38.4988 16.768C38.3194 16.6932 38.1567 16.5835 38.02 16.4453L31.13 9.5253C30.9918 9.3886 30.8821 9.22586 30.8073 9.04648C30.7324 8.86711 30.6938 8.67467 30.6938 8.4803C30.6938 8.28594 30.7324 8.0935 30.8073 7.91412C30.8821 7.73475 30.9918 7.57201 31.13 7.4353V7.4353C31.2658 7.29743 31.4277 7.18795 31.6063 7.11322C31.7848 7.03848 31.9764 7 32.17 7C32.3635 7 32.5552 7.03848 32.7337 7.11322C32.9122 7.18795 33.0741 7.29743 33.21 7.4353L40.11 14.3253C40.2503 14.4639 40.3617 14.629 40.4377 14.8109C40.5137 14.9929 40.5528 15.1881 40.5528 15.3853C40.5528 15.5825 40.5137 15.7777 40.4377 15.9597C40.3617 16.1417 40.2503 16.3067 40.11 16.4453V16.4453Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5289 11.925L29.3569 16.0969L31.4429 18.1829L35.6148 14.011L33.5289 11.925Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.27 14.0154L33.53 20.2754L21.16 32.6454C20.6006 33.1861 19.853 33.4884 19.075 33.4884C18.297 33.4884 17.5494 33.1861 16.99 32.6454L14.88 30.5654C14.3401 30.0156 14.0376 29.2759 14.0376 28.5054C14.0376 27.7349 14.3401 26.9951 14.88 26.4454V26.4454L27.27 14.0154Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.76 20.5154L27.02 26.7854L21.16 32.6454C20.6006 33.1861 19.853 33.4884 19.075 33.4884C18.297 33.4884 17.5494 33.1861 16.99 32.6454L14.88 30.5654C14.3401 30.0156 14.0376 29.2759 14.0376 28.5054C14.0376 27.7349 14.3401 26.9951 14.88 26.4454L20.76 20.5154Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9 38.5353L13.85 33.6853",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8797 30.5654L16.9797 32.6454L15.9797 33.6454C15.8438 33.7833 15.6819 33.8928 15.5034 33.9675C15.3248 34.0423 15.1332 34.0807 14.9397 34.0807C14.7461 34.0807 14.5545 34.0423 14.3759 33.9675C14.1974 33.8928 14.0355 33.7833 13.8997 33.6454C13.7618 33.5096 13.6523 33.3477 13.5776 33.1691C13.5028 32.9906 13.4644 32.799 13.4644 32.6054C13.4644 32.4119 13.5028 32.2203 13.5776 32.0417C13.6523 31.8632 13.7618 31.7013 13.8997 31.5654L14.8797 30.5654Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2999 30.5052L21.8999 29.1152",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M25.1601 28.6452L22.8301 26.3252",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0101 26.7853L25.6201 25.3953",
  stroke: "#281A3B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8698 24.9252L26.5498 22.6052",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7298 23.0653L29.3398 21.6753",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M14.88 26.3854L20.65 20.6154L20.75 20.5154L27 26.7854L24.39 29.4454L21.16 32.6854C20.6002 33.2291 19.8505 33.5332 19.07 33.5332C18.2896 33.5332 17.5399 33.2291 16.98 32.6854L14.88 30.5654C14.3363 30.0055 14.0322 29.2558 14.0322 28.4754C14.0322 27.695 14.3363 26.9453 14.88 26.3854Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6197 22.3553L25.1797 11.9253",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgVaccine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccine);
export default __webpack_public_path__ + "static/media/vaccine.d396afc4.svg";
export { ForwardRef as ReactComponent };